import React from "react"
import { find, get } from "lodash"
import { StaticQuery, graphql } from "gatsby"
import Form from "./form"

export default function Header(props) {
  return (
    <StaticQuery
      query={graphql`
        {
          allSanityPoll {
            nodes {
              _id
              name
              routing {
                identifier
                targetIdentifier
                conditions {
                  ... on SanityCondition {
                    variable
                    operator
                    value
                  }
                  ... on SanityLogicalOperator {
                    operator
                  }
                }
              }

              questions {
                __typename
                ... on SanityQuestionGroup {
                  title
                  identifier

                  questions {
                    __typename
                    ... on SanityTextInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityEmailInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanitySignature {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityNavigationButton {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      buttonText
                      targetIdentifier
                    }

                    ... on SanityTextArea {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityNumberInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityCurrencyInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      currency
                    }

                    ... on SanityDateInput {
                      __typename
                      maxDate
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityCheckbox {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      text
                      checkRequired
                      links {
                        name
                        url
                        file {
                          file {
                            asset {
                              url
                            }
                          }
                        }
                      }
                    }

                    ... on SanityResult {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      textblocks
                      subheadline
                      headline
                      callToAction {
                        text
                        state {
                          code
                        }
                        externalLink
                        internalLink {
                          slug {
                            current
                          }
                        }
                      }
                    }

                    ... on SanitySelection {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      options {
                        name
                        value
                      }
                    }

                    ... on SanityResultOptionPanels {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      resultOptions {
                        __typename
                        headline
                        subheadline
                        details
                        additionalInfo
                        price
                        identifierTo
                        externalLink
                        internalLink {
                          slug {
                            current
                          }
                        }
                        state {
                          code
                        }
                      }
                    }

                    ... on SanityPageBreak {
                      __typename
                      active
                    }

                    ... on SanityLoading {
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      uploadFiles
                      fileUrl
                      headline
                      subheadline
                      requestURL
                      requestParams
                      requestParamsConstants
                      durationInSeconds
                      calculationCode {
                        code
                      }
                    }

                    ... on SanitySummary {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      editIdentifier
                      identifierList {
                        key
                        value
                      }
                    }

                    ... on SanityUpload {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                      }
                      multipleFiles
                    }
                  }
                }

                ... on SanityQuestions {
                  questions {
                    ... on SanityTextInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityResultOptionPanels {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      resultOptions {
                        __typename
                        headline
                        subheadline
                        details
                        additionalInfo
                        price
                        identifierTo
                        externalLink
                        internalLink {
                          slug {
                            current
                          }
                        }
                        state {
                          code
                        }
                      }
                    }

                    ... on SanityEmailInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanitySignature {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityNavigationButton {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      buttonText
                      targetIdentifier
                    }

                    ... on SanityTextArea {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityNumberInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityCurrencyInput {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      currency
                    }

                    ... on SanityDateInput {
                      __typename
                      maxDate
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                    }

                    ... on SanityCheckbox {
                      __typename
                      question {
                        showNavigation
                        __typename
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      text
                      checkRequired
                      links {
                        name
                        url
                        file {
                          file {
                            asset {
                              url
                            }
                          }
                        }
                      }
                    }

                    ... on SanityResult {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      textblocks
                      subheadline
                      headline
                      callToAction {
                        text
                        state {
                          code
                        }
                        externalLink
                        internalLink {
                          slug {
                            current
                          }
                        }
                      }
                    }

                    ... on SanitySelection {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      options {
                        name
                        value
                      }
                    }

                    ... on SanityLoading {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      uploadFiles
                      fileUrl
                      requestURL
                      requestParams
                      requestParamsConstants
                      headline
                      subheadline
                      durationInSeconds
                      calculationCode {
                        code
                      }
                    }

                    ... on SanitySummary {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                        hint
                      }
                      editIdentifier
                      identifierList {
                        key
                        value
                      }
                    }

                    ... on SanityUpload {
                      __typename
                      question {
                        __typename
                        showNavigation
                        description
                        identifier
                        text
                        required
                      }
                      multipleFiles
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <Form
            {...props}
            form={find(get(data, "allSanityPoll.nodes"), form => {
              return (
                form._id === props.form._id ||
                form._id === `drafts.${props.form._id}`
              )
            })}
          />
        )
      }}
    />
  )
}
